import CompanySettings from 'components/company/revamp/index';
import Notification from 'components/layouts/notification';
import _debounce from 'lodash/debounce';
import { Hooks } from 'providers';
import {
  useCallback, useContext, useEffect, useState,
} from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { HIT_LOGOUT } from 'redux/actions/auth';
import {
  VALIDATION_COMPANY,
  VALIDATION_DASHBOARD,
} from 'redux/actions/validationRole';

import CompanyPlaceholder from 'assets/img/company_placeholder.png';
import Bell from 'assets/img/icons/bell.svg';
import Help from 'assets/img/icons/help.svg';
import Setting from 'assets/img/icons/settings.svg';
import UserPlaceholder from 'assets/img/rizelogos.png';

function Header(props) {
  const history = useHistory();
  const { state } = useLocation();
  const { t, i18n } = useTranslation();
  const [isShow, setIsShow] = useState(false);

  const changeLanguage = (lng) => {
    const language = !lng ? 'en' : 'id';
    i18n.changeLanguage(language);
    localStorage.setItem('language', language);
  };
  const {
    sideBar, setSideBar, keywordBoard, setKeywordBoard,
  } = useContext(Hooks);
  const [miniModal, setMiniModal] = useState(false);
  const dispatch = useDispatch();
  const { validationCompany, validationDashboard } = useSelector((state) => ({
    validationCompany: state?.auth?.company,
    validationDashboard: state?.auth?.role,
  }));
  const path = history.location.pathname;

  useEffect(() => {
    const path = history.location.pathname;
    const pathRoot = path.split('/')[1];

    // hideSideBar
    const shouldSideBar = ['/board', '/company', '/profile'].includes(path)
    || ['/detail-board', '/audit-matrix'].includes(pathRoot);
    setSideBar(!shouldSideBar && !state?.sideBarHide);
  }, [history.location.pathname, state?.sideBarHide]);

  const isBoardPage = path === '/board';

  const bgNavbar = isBoardPage ? 'bg-tranparent fixed-top' : 'bg-white sticky-top';
  const textNavbar = isBoardPage ? 'text-white' : 'text-dark';
  const borderNavbar = isBoardPage ? 'none' : '';

  const changeHandler = (event) => {
    if (event.target.value === '') {
      setKeywordBoard(undefined);
    } else {
      setKeywordBoard(event.target.value);
    }
  };

  useEffect(() => {
    if (props.loginType === 'users') {
      dispatch({
        type: VALIDATION_DASHBOARD,
        payload: {
          board_id: localStorage.getItem('board_id'),
        },
        types: 'dashboard',
      });
    }
  }, [validationDashboard.is_member == undefined]);

  const debouncedChangeHandler = useCallback(_debounce(changeHandler, 300), []);
  const defaultLang = localStorage.getItem('language');

  const isHide = history.location.pathname.split('/')[3] === 'team-employee'
    || history.location.pathname.split('/')[3] === 'department-employee';

  const renderHeader = () => {
    const { pathname } = history.location;
    switch (props.loginType) {
      case 'admin':
        return (
          <>
            <a
              className="sidebar-toggle d-flex mr-3 "
              aria-hidden="true"
              onClick={() => {
                (pathname !== '/board'
                  || pathname !== '/company'
                  || pathname !== '/profile'
                  || pathname.split('/')[3] === 'team-employee'
                  || pathname.split('/')[3] === 'department-employee'
                  || pathname.split('/')[1] !== 'detail-board')
                  && setSideBar(!sideBar);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-menu align-self-center"
                className={`${
                  (history.location.pathname === '/board'
                    || history.location.pathname === '/company'
                    || history.location.pathname === '/profile'
                    || history.location.pathname.split('/')[3]
                      === 'team-employee'
                    || history.location.pathname.split('/')[3]
                      === 'department-employee'
                    || history.location.pathname.split('/')[1]
                      === 'detail-board'
                    || history.location.pathname.split('/')[1]
                      === 'audit-matrix')
                  && 'd-none'
                }`}
              >
                <line x1="3" y1="12" x2="21" y2="12" />
                <line x1="3" y1="6" x2="21" y2="6" />
                <line x1="3" y1="18" x2="21" y2="18" />
              </svg>
            </a>
            <Link
              to="/company"
              onClick={() => dispatch({
                type: VALIDATION_COMPANY,
              })}
              className="rNoDecoLink"
              style={{
                pointerEvents: !(
                  validationCompany?.is_member || validationDashboard?.is_member
                )
                  ? 'none'
                  : 'auto',
                cursor: !(
                  validationCompany?.is_member || validationDashboard?.is_member
                )
                  ? 'default'
                  : 'pointer',
              }}
            >
              <img
                src={
                  localStorage.getItem('pictCompany') !== 'undefined'
                  && localStorage.getItem('pictCompany') !== 'null'
                    ? process.env.REACT_APP_CDN
                      + localStorage.getItem('pictCompany')
                    : CompanyPlaceholder
                }
                className="avatar img-fluid rounded mr-1"
                alt="companylogo"
              />
              {!localStorage.getItem('admin') && (
                <span className={textNavbar}>
                  {localStorage.getItem('company_name')}
                </span>
              )}
            </Link>
            <div
              className="dropdown-menu dropdown-menu-lg company-list"
              aria-labelledby="alertsDropdown2"
            >
              <a className="dropdown-item">
                <Link to="/company">
                  <img
                    src={CompanyPlaceholder}
                    className="avatar img-fluid rounded mr-1"
                    alt="companylogo"
                  />
                  {' '}
                  Company A
                </Link>
              </a>
              <a className="dropdown-item" href="pages-profile.html">
                <img
                  src={CompanyPlaceholder}
                  className="avatar img-fluid rounded mr-1"
                  alt="companylogo"
                />
                {' '}
                Company B
              </a>
              <a className="dropdown-item" href="pages-profile.html">
                <img
                  src={CompanyPlaceholder}
                  className="avatar img-fluid rounded mr-1"
                  alt="companylogo"
                />
                {' '}
                Company C
              </a>
              <a className="dropdown-item" href="pages-profile.html">
                <img
                  src={CompanyPlaceholder}
                  className="avatar img-fluid rounded mr-1"
                  alt="companylogo"
                />
                {' '}
                Company D
              </a>
            </div>
            {!localStorage.getItem('admin') && (
              <form className="form-inline d-none d-sm-inline-block">
                <input
                  className="form-control form-control-no-border navbar-search ml-sm-4"
                  type="text"
                  placeholder="Search Board"
                  aria-label="Search"
                  onChange={(e) => debouncedChangeHandler(e)}
                />
              </form>
            )}

            <div className="navbar-collapse collapse justify-content-end">
              <center className="d-flex my-auto">
                <div className="switch">
                  <input
                    id="language-toggle"
                    className="check-toggle check-toggle-round-flat"
                    type="checkbox"
                    checked={defaultLang !== 'en'}
                    onClick={(e) => changeLanguage(e.target.checked)}
                  />
                  <label htmlFor="language-toggle" />
                  <span className="on" onClick={() => changeLanguage('en')}>
                    EN
                  </span>
                  <span className="off" onClick={() => changeLanguage('id')}>
                    IN
                  </span>
                </div>
              </center>
              <ul className="navbar-nav">
                <li className="nav-item dropdown">
                  <a
                    className="nav-icon dropdown-toggle ml-2 d-inline-block d-sm-none"
                    href="#"
                    data-toggle="dropdown"
                  >
                    <div className="position-relative">
                      <i
                        className="align-middle mt-n1"
                        data-feather="settings"
                      />
                    </div>
                  </a>
                  <a
                    className="nav-link nav-link-user d-sm-inline-block"
                    onClick={() => setMiniModal(!miniModal)}
                  >
                    <img
                      src={
                        localStorage.getItem('pictProfile') !== 'undefined'
                        && localStorage.getItem('pictProfile') !== 'null'
                          ? process.env.REACT_APP_CDN
                            + localStorage.getItem('pictProfile')
                          : CompanyPlaceholder
                      }
                      className="avatar img-fluid rounded mr-1"
                      alt="user placeholder"
                    />
                    {' '}
                    <span className={textNavbar} style={{ userSelect: 'none' }}>
                      {localStorage.getItem('name') || 'User Rize'}
                    </span>
                  </a>

                  <div
                    className={`dropdown-menu dropdown-menu-right ${
                      miniModal && 'show'
                    }`}
                    style={{ borderRadius: '20px' }}
                  >
                    <Link
                      className="dropdown-item"
                      to="/profile"
                      onClick={() => setMiniModal(!miniModal)}
                    >
                      Profile
                    </Link>
                    <div className="dropdown-divider" />
                    <a className="dropdown-item" href="#">
                      Help
                    </a>
                    <a
                      className="dropdown-item"
                      onClick={async () => {
                        if (localStorage.getItem('history') === 'admin') {
                          await history.push('/administrator');
                          await dispatch({
                            type: HIT_LOGOUT,
                          });
                        } else {
                          await history.push('/signin');
                          await dispatch({
                            type: HIT_LOGOUT,
                          });
                        }
                      }}
                    >
                      Sign out
                    </a>
                  </div>
                </li>
              </ul>
            </div>
          </>
        );
        break;

      case 'user':
        return (
          <>
            {!localStorage.getItem('admin') && (
              <a
                className="sidebar-toggle d-flex mr-3 "
                onClick={() => {
                  (history.location.pathname !== '/board'
                    || history.location.pathname !== '/company'
                    || history.location.pathname !== '/profile'
                    || history.location.pathname.split('/')[3]
                      === 'team-employee'
                    || history.location.pathname.split('/')[3]
                      === 'department-employee'
                    || history.location.pathname.split('/')[1]
                      !== 'detail-board')
                    && setSideBar(!sideBar);
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="feather feather-menu align-self-center"
                  className={`${
                    (history.location.pathname === '/board'
                      || history.location.pathname === '/company'
                      || history.location.pathname === '/profile'
                      || history.location.pathname.split('/')[3]
                        === 'team-employee'
                      || history.location.pathname.split('/')[3]
                        === 'department-employee'
                      || history.location.pathname.split('/')[1]
                        === 'detail-board'
                      || history.location.pathname.split('/')[1]
                        === 'audit-matrix')
                    && 'd-none'
                  }`}
                >
                  <line x1="3" y1="12" x2="21" y2="12" />
                  <line x1="3" y1="6" x2="21" y2="6" />
                  <line x1="3" y1="18" x2="21" y2="18" />
                </svg>
              </a>
            )}
            <div
              onClick={() => setIsShow(!isShow)}
              className="rNoDecoLink"
              style={{
                pointerEvents: !(
                  validationCompany?.is_member || validationDashboard?.is_member
                )
                  ? 'none'
                  : 'auto',
                cursor: !(
                  validationCompany?.is_member || validationDashboard?.is_member
                )
                  ? 'default'
                  : 'pointer',
              }}
            >
              <img
                src={
                  localStorage.getItem('pictCompany') !== 'undefined'
                  && localStorage.getItem('pictCompany') !== 'null'
                    ? process.env.REACT_APP_CDN
                      + localStorage.getItem('pictCompany')
                    : CompanyPlaceholder
                }
                className="avatar img-fluid rounded mr-1"
                alt="companylogo"
              />
              {!localStorage.getItem('admin') && (
                <span className={textNavbar}>
                  {localStorage.getItem('company_name')}
                </span>
              )}
            </div>
            <div
              className="dropdown-menu dropdown-menu-lg company-list"
              aria-labelledby="alertsDropdown2"
            >
              <a className="dropdown-item">
                <Link to="/company">
                  <img
                    src={CompanyPlaceholder}
                    className="avatar img-fluid rounded mr-1"
                    alt="companylogo"
                  />
                  {' '}
                  Company A
                </Link>
              </a>
              <a className="dropdown-item" href="pages-profile.html">
                <img
                  src={CompanyPlaceholder}
                  className="avatar img-fluid rounded mr-1"
                  alt="companylogo"
                />
                {' '}
                Company B
              </a>
              <a className="dropdown-item" href="pages-profile.html">
                <img
                  src={CompanyPlaceholder}
                  className="avatar img-fluid rounded mr-1"
                  alt="companylogo"
                />
                {' '}
                Company C
              </a>
              <a className="dropdown-item" href="pages-profile.html">
                <img
                  src={CompanyPlaceholder}
                  className="avatar img-fluid rounded mr-1"
                  alt="companylogo"
                />
                {' '}
                Company D
              </a>
            </div>
            <div className="navbar-collapse collapse justify-content-end">
              <center className="d-flex my-auto">
                <div className="switch">
                  <input
                    id="language-toggle"
                    className="check-toggle check-toggle-round-flat"
                    type="checkbox"
                    checked={defaultLang !== 'en'}
                    onClick={(e) => changeLanguage(e.target.checked)}
                  />
                  <label htmlFor="language-toggle" />
                  <span className="on" onClick={() => changeLanguage('en')}>
                    EN
                  </span>
                  <span className="off" onClick={() => changeLanguage('id')}>
                    IN
                  </span>
                </div>
              </center>
              <Notification />
              <ul className="navbar-nav">
                <li className="nav-item dropdown">
                  <a
                    className="nav-icon dropdown-toggle ml-2 d-inline-block d-sm-none"
                    href="#"
                    data-toggle="dropdown"
                  >
                    <div className="position-relative">
                      <i
                        className="align-middle mt-n1"
                        data-feather="settings"
                      />
                    </div>
                  </a>
                  <a
                    className="nav-link nav-link-user d-sm-inline-block"
                    onClick={() => setMiniModal(!miniModal)}
                  >
                    <img
                      src={
                        localStorage.getItem('pictProfile') !== 'undefined'
                        && localStorage.getItem('pictProfile') !== 'null'
                          ? process.env.REACT_APP_CDN
                            + localStorage.getItem('pictProfile')
                          : CompanyPlaceholder
                      }
                      className="avatar img-fluid rounded mr-1"
                      alt="user placeholder"
                    />
                    {' '}
                    <span className={textNavbar} style={{ userSelect: 'none' }}>
                      {localStorage.getItem('name') || 'User Rize'}
                    </span>
                  </a>

                  <div
                    className={`dropdown-menu dropdown-menu-right ${
                      miniModal && 'show'
                    }`}
                    style={{ borderRadius: '20px' }}
                  >
                    <Link
                      className="dropdown-item"
                      to="/profile"
                      onClick={() => setMiniModal(!miniModal)}
                    >
                      Profile
                    </Link>
                    <a
                      className="dropdown-item"
                      href="https://supportrize.tawk.help/"
                      target="blank"
                    >
                      Help
                    </a>
                    <a
                      className="dropdown-item"
                      onClick={async () => {
                        if (localStorage.getItem('history') === 'admin') {
                          await history.push('/administrator');
                          await dispatch({
                            type: HIT_LOGOUT,
                          });
                        } else {
                          await history.push('/signin');
                          await dispatch({
                            type: HIT_LOGOUT,
                          });
                        }
                      }}
                    >
                      Sign out
                    </a>
                  </div>
                </li>
              </ul>
            </div>
          </>
        );
        break;

      case 'pt-employee':
      case 'kpi-admin':
        return (
          <>
            {!localStorage.getItem('admin') && (
              <a
                className="sidebar-toggle d-flex mr-3 "
                onClick={() => {
                  (history.location.pathname !== '/board'
                    || history.location.pathname !== '/company'
                    || history.location.pathname !== '/profile'
                    || history.location.pathname.split('/')[3]
                      === 'team-employee'
                    || history.location.pathname.split('/')[3]
                      === 'department-employee'
                    || history.location.pathname.split('/')[1]
                      !== 'detail-board')
                    && setSideBar(!sideBar);
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="feather feather-menu align-self-center"
                  className={`${
                    (history.location.pathname === '/board'
                      || history.location.pathname === '/company'
                      || history.location.pathname === '/profile'
                      || history.location.pathname.split('/')[3]
                        === 'team-employee'
                      || history.location.pathname.split('/')[3]
                        === 'team-employee'
                      || history.location.pathname.split('/')[3]
                        === 'department-employee'
                      || history.location.pathname.split('/')[1]
                        === 'detail-board'
                      || history.location.pathname.split('/')[1]
                        === 'audit-matrix')
                    && 'd-none'
                  }`}
                >
                  <line x1="3" y1="12" x2="21" y2="12" />
                  <line x1="3" y1="6" x2="21" y2="6" />
                  <line x1="3" y1="18" x2="21" y2="18" />
                </svg>
              </a>
            )}

            <div className="navbar-collapse collapse justify-content-end">
              <ul className="navbar-nav d-flex align-items-center">
                <li className="mr-3">
                  <img
                    src={Help}
                    alt="help.svg"
                    style={{ cursor: 'pointer' }}
                  />
                </li>
                <li className="mr-3">
                  <img
                    src={Bell}
                    alt="bell.svg"
                    style={{ cursor: 'pointer' }}
                  />
                </li>
                <li className="mr-5">
                  <img
                    src={Setting}
                    alt="setting.svg"
                    style={{ cursor: 'pointer' }}
                  />
                </li>
                <li className="mr-2">
                  <img
                    src={UserPlaceholder}
                    className="rounded-lg border"
                    style={{
                      aspectRatio: '1/1',
                      objectFit: 'contain',
                      objectPosition: 'center',
                      width: '35px',
                      height: '35px',
                    }}
                    alt="profile.jpg/.jpeg/.png"
                  />
                </li>
                <li
                  className="nav-item dropdown d-flex align-items-center"
                  onClick={() => setMiniModal(!miniModal)}
                >
                  <div
                    className={textNavbar}
                    style={{
                      width: '150px',
                      cursor: 'pointer',
                      fontSize: '11px',
                      fontWeight: '700',
                    }}
                  >
                    {localStorage.getItem('name') || 'Arby Kusuma'}
                  </div>
                  <a className="nav-link nav-link-user dropdown-toggle d-flex justify-conten-between d-sm-inline-block " />

                  {/* MODAL */}
                  <div
                    className={`dropdown-menu dropdown-menu-right ${
                      miniModal && 'show'
                    }`}
                  >
                    <Link
                      className="dropdown-item"
                      to="/profile"
                      onClick={() => setMiniModal(!miniModal)}
                    >
                      Profile
                    </Link>
                    <div className="dropdown-divider" />
                    <a className="dropdown-item" href="#">
                      Help
                    </a>
                    <a
                      className="dropdown-item"
                      onClick={async () => {
                        if (localStorage.getItem('historyV2') === 'adminV2') {
                          await dispatch({
                            type: HIT_LOGOUT,
                          });
                          await history.push('/v2/kpi/login');
                        } else {
                          await dispatch({
                            type: HIT_LOGOUT,
                          });
                          await history.push('/v2/kpi/login-employee');
                        }
                      }}
                    >
                      Sign out
                    </a>
                  </div>
                </li>
              </ul>
            </div>
          </>
        );
        break;

      default:
        break;
    }
  };

  return (
    <>
      <CompanySettings show={isShow} setShow={setIsShow} />
      <nav
        className={`navbar navbar-expand navbar-light tw-z-[1001] ${bgNavbar} ${
          isHide ? 'd-none' : ''
        }`}
        style={{ zIndex: 997, border: borderNavbar }}
      >
        {renderHeader()}
      </nav>
    </>
  );
}

export default Header;
